
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investments/collaborate",
      function () {
        return require("private-next-pages/investments/collaborate.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investments/collaborate"])
      });
    }
  